import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Checkbox,
  InputItem,
  Picker,
  Toast,
} from "antd-mobile-v2";
import "./index.less";
import React, { Component } from "react";
import { getCity } from "../../public/getCityData";
import { createForm } from "rc-form";
import tool from "../../api/tool";
import { userInfoData } from "../../public/getUserInfo";
import allUrl from "../../api/allUrl";
import { get, headerGet, post, postRaw } from "../../api/service/services";
const Item = List.Item;
let submitData = {};
class Addacate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cityData: [],
      cityNameData: [],
      userData: {},
    };
  }
  // 获取个人信息
  getUserData = async () => {
    let userData = tool.get("userInfoData");
    console.log(userData, "个人信息数据");
    if (userData) {
      this.setState({ userData: userData });
    } else {
      let data = await userInfoData();
      this.setState({ userData: data });
    }
  };
  // 下一步之前数据提交
  onSubmit = () => {
    let asscateData = tool.get("asscateData") || [];
    const { userData } = this.state;
    this.props.form.validateFields(async (error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      let strData = await this.Authentication({
        name: values["jointPersonName"],
        idNumber: values["jointPersonId"],
      });
      if (strData && strData.code && strData.code != 200) {
        Toast.fail(strData.msg, 1);
        return;
      }
      values["cityName"] = submitData["cityname"];
      values["personProvinceCode"] = values["address"][0];
      values["personProvinceName"] = values["cityName"][0];
      values["personCityCode"] = values["address"][1];
      values["personCityName"] = values["cityName"][1];
      values["personRegionCode"] = values["address"][2];
      values["personRegionName"] = values["cityName"][2];
      let ininData = tool.get("editData") || {};
      if (JSON.stringify(ininData) != "{}") {
        asscateData[ininData.key] = values;
      } else {
        let filData = asscateData.filter((item) => {
          return item["jointPersonId"] == values["jointPersonId"];
        });
        if (filData.length > 0) {
          Toast.fail("联名人不能重复", 1);
          return;
        }
        if (userData["idNumber"] == values["jointPersonId"]) {
          Toast.fail("主访人和联名人不能重复", 1);
          return;
        }
        asscateData.push(values);
      }
      tool.set("asscateData", asscateData);
      this.props.history.goBack();
    });
  };
  // 身份验证
  Authentication = (params) => {
    return new Promise((resolve, reject) => {
      get(allUrl.register.Authentication, params)
        .then((res) => {
          if (res.success === true && res.code == 200) {
            resolve(res);
          } else {
            resolve(res);
          }
        })
        .catch((error) => {
          reject(error);
        });
    })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.data;
      });
  };
  async componentDidMount() {
    let data;
    data = tool.get("cityData");
    if (!data) {
      data = await getCity();
    }
    await this.getUserData();
    this.setState({ cityData: data });
  }
  // 城市选中时的调用
  cityOk = (val) => {
    let newData = [];
    const { cityData } = this.state;
    for (var i = 0; i < val.length; i++) {
      this.filterCityName(val[i], cityData, newData);
    }
    submitData["cityname"] = newData;
    this.setState({ cityNameData: newData });
  };
  // 根据key过滤率label
  filterCityName = (val, cityData, newData) => {
    for (var i = 0; i < cityData.length; i++) {
      if (cityData[i].value == val) {
        newData.push(cityData[i].label);
      } else {
        if (cityData[i].children && cityData[i].children.length > 0) {
          this.filterCityName(val, cityData[i].children, newData);
        }
      }
    }
    return newData;
  };
  render() {
    const { getFieldProps, getFieldError, resetFields } = this.props.form;
    const { count, flagCode } = this.state;
    let ininData = tool.get("editData");
    return (
      <div className="addscate-wrap">
        <form>
          <List style={{ paddingTop: "0px" }}>
            <InputItem
              {...getFieldProps("jointPersonName", {
                initialValue:
                  ininData && ininData.data && ininData.data.jointPersonName
                    ? ininData.data.jointPersonName
                    : "",
                rules: [{ required: true, message: "请输入身份证姓名" }],
              })}
              clear
              error={!!getFieldError("jointPersonName")}
              onErrorClick={() => {
                alert(getFieldError("jointPersonName").join("、"));
              }}
              placeholder="请输入身份证姓名"
            >
              <span style={{ color: "red" }}>*</span> 姓名
            </InputItem>
            <InputItem
              {...getFieldProps("jointPersonId", {
                initialValue:
                  ininData && ininData.data && ininData.data.jointPersonId
                    ? ininData.data.jointPersonId
                    : "",
                rules: [
                  { required: true, message: "请输入身份证号码" },
                  {
                    required: false,
                    pattern: new RegExp(
                      /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                      "g"
                    ),
                    message: "请输入正确的身份证号码",
                  },
                ],
              })}
              clear
              error={!!getFieldError("jointPersonId")}
              onErrorClick={() => {
                alert(getFieldError("jointPersonId").join("、"));
              }}
              placeholder="请输入身份证号码"
            >
              <span style={{ color: "red" }}>*</span> 证件号码
            </InputItem>
            <Picker
              data={this.state.cityData}
              cols={3}
              {...getFieldProps("address", {
                initialValue:
                  ininData && ininData.data && ininData.data.address
                    ? ininData.data.address
                    : [],
                rules: [{ required: true, message: "请选择地址" }],
              })}
              onOk={this.cityOk}
              title="选择地址"
            >
              <List.Item arrow="horizontal">
                <span style={{ color: "red" }}>*</span> 地址
              </List.Item>
            </Picker>
            <InputItem
              {...getFieldProps("personAddress", {
                initialValue:
                  ininData && ininData.data && ininData.data.personAddress
                    ? ininData.data.personAddress
                    : "",
                rules: [{ required: true, message: "请输入详细地址" }],
              })}
              clear
              error={!!getFieldError("personAddress")}
              onErrorClick={() => {
                alert(getFieldError("personAddress").join("、"));
              }}
              placeholder="请输入详细地址"
            >
              <span style={{ color: "red" }}>*</span> 详细地址
            </InputItem>
          </List>
          <Item>
            <Button type="primary" onClick={this.onSubmit}>
              保存
            </Button>
          </Item>
        </form>
      </div>
    );
  }
}
export default createForm()(Addacate);
